<app-modal-container
    #modalContainer
    [height]="300"
    [width]="540"
>
  <div class="modal-holder">
    <div class="icon-holder">
      <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16.5" cy="16" r="16" fill="black"/>
        <path d="M13 16.5L15.5 19L20.5 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h2 class="title">Ви впевнені, що бажаєте зняти медичні товари з карантину?</h2>
    <p class="description">
      Зняття з карантину медичних товарів дозволить проводити їх списання на пацієнтів.
    </p>
    <div class="button-holder">
      <button class="btn btn-grey" (click)="onCancel()">Назад</button>
      <button class="btn btn-black" (click)="onConfirm()">Вперед</button>
    </div>
  </div>
</app-modal-container>